var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',{attrs:{"title":_vm.title,"icon":_vm.icon,"id":"interactive-map","withPadding":!_vm.isMobile}},[_c('map-modal',{ref:"mapModal"}),_c('initiative-map',{attrs:{"config":_vm.mapConfig,"showFullscreen":true},on:{"fullscreen":_vm.onFullscreenSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }